export function NewPostPage() {
  return (
    <div style={{ padding: 20, color: 'var(--text-body)', fontFamily: 'var(--font-sans)' }}>
      New post
    </div>
  )
}
